import { Btn, Drawer, StateBadge } from "../../ui";
import type { DeviceDTO } from "../../../api/contract";
import type { DeviceTaskItem } from "../../api";
import { deviceStateKey, formatRelative, getTaskName } from "./utils";

interface DeviceDetailDrawerProps {
  selected: DeviceDTO | null | undefined;
  selectedId: string | null;
  selectedTasks: DeviceTaskItem[];
  selectedTasksErr: string | null;
  renameValue: string;
  onClose: () => void;
  onRenameChange: (value: string) => void;
  onSubmitRename: () => void;
  onRevoke: (id: string) => void;
}

export function DeviceDetailDrawer({
  selected,
  selectedId,
  selectedTasks,
  selectedTasksErr,
  renameValue,
  onClose,
  onRenameChange,
  onSubmitRename,
  onRevoke,
}: DeviceDetailDrawerProps) {
  return (
    <Drawer
      open={!!selectedId}
      onClose={onClose}
      title={selected ? selected.label : ""}
      sub={selected ? selected.id : ""}
    >
      {selected && (
        <div className="col gap-16">
          <div className="grid grid-2 gap-12">
            <div className="preview-box" style={{ padding: "12px 14px" }}>
              <div className="muted" style={{ fontSize: 10 }}>STATO</div>
              <div className="mt-4"><StateBadge state={deviceStateKey(selected)} /></div>
            </div>
            <div className="preview-box" style={{ padding: "12px 14px" }}>
              <div className="muted" style={{ fontSize: 10 }}>TASK FATTI</div>
              <div className="mt-4 mono" style={{ fontSize: 18 }}>{selected.tasksDone}</div>
            </div>
            <div className="preview-box" style={{ padding: "12px 14px" }}>
              <div className="muted" style={{ fontSize: 10 }}>ULTIMO ACCESSO</div>
              <div className="mt-4" style={{ fontSize: 13 }}>{formatRelative(selected.lastSeenAt)}</div>
            </div>
            <div className="preview-box" style={{ padding: "12px 14px" }}>
              <div className="muted" style={{ fontSize: 10 }}>AGGIUNTA</div>
              <div className="mt-4" style={{ fontSize: 13 }}>{formatRelative(selected.createdAt)}</div>
            </div>
          </div>

          <div className="field">
            <label className="label">Nome</label>
            <div className="row gap-8">
              <input
                className="input"
                value={renameValue}
                onChange={(e) => onRenameChange(e.target.value)}
                disabled={!!selected.revokedAt}
              />
              <Btn
                variant="primary"
                disabled={!!selected.revokedAt || renameValue.trim() === selected.label}
                onClick={onSubmitRename}
              >
                Salva
              </Btn>
            </div>
          </div>

          <div>
            <div className="label" style={{ marginBottom: 8 }}>Ultimi task ({selectedTasks.length})</div>
            {selectedTasksErr && (
              <div style={{ padding: 12, color: "var(--danger)", fontSize: 12 }}>{selectedTasksErr}</div>
            )}
            {!selectedTasksErr && selectedTasks.length === 0 && (
              <div style={{ padding: 12, color: "var(--text-2)", fontSize: 12 }}>Nessun task per questo device</div>
            )}
            {selectedTasks.length > 0 && (
              <div className="log" style={{ maxHeight: 280 }}>
                {selectedTasks.map((t) => (
                  <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 14px", borderBottom: "1px solid var(--line)" }}>
                    <span className="mono" style={{ fontSize: 11, color: "var(--text-2)" }}>#{t.id}</span>
                    <span style={{ flex: 1, fontSize: 13 }}>{getTaskName(t)}</span>
                    <StateBadge state={t.state} />
                    <span className="mono" style={{ fontSize: 11, color: "var(--text-2)" }}>{formatRelative(t.updatedAt)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="row gap-8">
            <div className="grow"></div>
            {!selected.revokedAt && (
              <Btn variant="danger" onClick={() => onRevoke(selected.id)}>Revoca estensione</Btn>
            )}
          </div>
        </div>
      )}
    </Drawer>
  );
}
